function ComingSoon() {
    return (
        <main className="page">
            <section className="card">
                <h1>Coming Soon</h1>
                <p>We’re building your pages. Stay tuned!</p>
            </section>
        </main>
    );
}

export default ComingSoon;
